import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";

import { App } from "@/App";

import "./index.css";

const root = document.querySelector("#app");

if (!root) {
	throw new Error("Elemento #app não encontrado.");
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 1, refetchOnWindowFocus: false },
		mutations: { retry: false },
	},
});

ReactDOM.createRoot(root).render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>,
);
